export enum JobDetailsTabs {
  OVERVIEW = 'Overview',
  BILLING = 'Billing',
  HISTORY = 'History'
}

export const JobDetailsTabsList = [
  { id: JobDetailsTabs.OVERVIEW, title: JobDetailsTabs.OVERVIEW },
  { id: JobDetailsTabs.BILLING, title: JobDetailsTabs.BILLING },
  { id: JobDetailsTabs.HISTORY, title: JobDetailsTabs.HISTORY }
];

export enum ReferralsEarningsTabs {
  REFERRALS = 'Referrals',
  EARNINGS = 'Earnings'
}

export enum ExpenseTabs {
  TEAM = 'TEAM',
  COMPANY = 'COMPANY'
}

export enum JobDetailsTabs {
  Overview = 'Overview',
  History = 'History',
  Billing = 'Billing'
}
